import React, { memo, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { IconButton, Tooltip, Stack, Icon, Typography } from 'investira.react.components';
import { validators } from 'investira.sdk';
import { AVALIACAO_RESPOSTA_TIPO } from '../../../../enums';
import { BulkContextActions, DataTable } from '../../../../components/organisms';
import withAvaliacoesQuestoes from '../../../../hoc/withAvaliacoesQuestoes';
const QuestoesSettings = memo(props => {
  const {
    enquadramentos,
    state,
    columns,
    renderDetailPanel,
    onBulkDeleteClick,
    ...restProps
  } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const xColumns = useMemo(() => {
    return [{
      id: 'avaliacao_questao_id',
      accessorKey: 'avaliacao_questao_id',
      header: 'ID',
      enableColumnActions: false,
      enableSorting: false,
      size: 40,
      muiTableHeadCellProps: {
        sx: {
          textAlign: 'right'
        }
      },
      Cell: ({
        cell
      }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return cell.getValue();
      }
    }, {
      id: 'avaliacao_questao',
      accessorKey: 'avaliacao_questao',
      header: 'Questão',
      enableColumnActions: false,
      enableSorting: false,
      //size: 200,
      muiTableHeadCellProps: {
        sx: {
          minWidth: '300px !important',
          width: '100%'
        }
      },
      Cell: ({
        cell
      }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return cell.getValue();
      }
    }, {
      id: 'interna',
      accessorKey: 'interna',
      header: 'Interna',
      enableColumnActions: false,
      enableSorting: false,
      size: 80,
      muiTableHeadCellProps: {
        sx: {
          textAlign: 'center'
        }
      },
      muiTableBodyCellProps: {
        sx: {
          textAlign: 'center'
        }
      },
      Cell: ({
        cell
      }) => {
        if (cell.getValue() === true) {
          return <Icon iconName="check" size={18} color="success" />;
        }
        return null;
      }
    }, {
      id: 'resposta_tipo',
      accessorKey: 'resposta_tipo',
      header: 'Tipo',
      enableColumnActions: false,
      enableSorting: false,
      muiTableHeadCellProps: {
        sx: {
          width: '100% !important'
        }
      },
      Cell: ({
        cell
      }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return AVALIACAO_RESPOSTA_TIPO[cell.getValue()].descricao;
      }
    }, {
      id: 'avaliacao_secao_sigla',
      accessorKey: 'avaliacao_secao_sigla',
      header: 'Sessão',
      enableColumnActions: false,
      enableSorting: false,
      muiTableHeadCellProps: {
        sx: {
          width: '100% !important'
        }
      },
      Cell: ({
        cell
      }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return <Typography variant="caption">{cell.getValue()}</Typography>;
      }
    }];
  }, []);
  const xProps = {
    columns: xColumns,
    data: props.questoes,
    readData: props.readQuestoes,
    isLoading: props.isLoading,
    initialState: {
      pagination: props.pagination,
      columnVisibility: {
        carteira: false
      },
      columnSizing: {
        // Define larguras fixas para as colunas de seleção e ações
        'mrt-row-select': 50,
        // Largura fixa para a coluna de seleção
        'mrt-row-actions': 80 // Largura fixa para a coluna de ações
      },
      density: 'comfortable'
    },
    manualFiltering: true,
    manualSorting: true,
    manualPagination: true,
    getRowId: row => row.log_id,
    state: {
      isLoading: Boolean(props.isLoading),
      pagination: props.pagination || {
        pageIndex: 0,
        pageSize: 25
      },
      showProgressBars: props.isRefetching,
      columnFilters: props.columnFilters || [],
      sorting: props.sorting || [],
      rowSelection: props.rowSelection || {}
    },
    rowCount: props.rowCount || 0,
    onColumnFiltersChange: props.setColumnFilters,
    onSortingChange: props.setSorting,
    onPaginationChange: props.setPagination,
    onRowSelectionChange: props.setRowSelection,
    onGlobalFilterChange: props.setGlobalFilter,
    //onBulkDeleteClick: props.bulkDeleteLogs,
    enableRowSelection: true,
    renderTopToolbarCustomActions: ({
      table
    }) => {
      const selectedRows = table.getSelectedRowModel().rows;
      const isSomeRowSelected = selectedRows.length > 0;
      return <BulkContextActions onDeleteClick={() => {
        props.bulkDeleteQuestoes(selectedRows);
      }} disabled={props.isLoading || props.isRefetching || !isSomeRowSelected} />;
    },
    muiTableContainerProps: {
      sx: {
        maxWidth: '100%' // Garante que a tabela ocupe 100% do espaço disponível
      }
    },
    displayColumnDefOptions: {
      'mrt-row-actions': {
        size: 80 // largura em pixels para a coluna de ações
      },
      'mrt-row-select': {
        size: 50 // largura em pixels para a coluna de seleção
      }
    },
    renderRowActions: ({
      row
    }) => {
      return <Stack direction="row" spacing={1}>
          <Tooltip title="Editar">
            <span>
              <IconButton color="primary" onClick={() => navigate(`${location.pathname}/edit/${row.original.avaliacao_questao_id}`, {
              state: row.original
            })}>
                <Icon iconName="edit" size={18} />
              </IconButton>
            </span>
          </Tooltip>
        </Stack>;
    },
    ...restProps
  };
  return <DataTable {...xProps} />;
});
QuestoesSettings.displayName = 'QuestoesSettings';
export default withAvaliacoesQuestoes(QuestoesSettings);
